// extracted by mini-css-extract-plugin
module.exports = {"main":"StoryCard_main__hIizX","blackedOut":"StoryCard_blackedOut__evk6J","readmoreicon":"StoryCard_readmoreicon__cnvk5","invitePill":"StoryCard_invitePill___DEGr"};